/*
 * The MIT License
 *
 * Copyright (c) 2016 Juan Cruz Viotti. https://github.com/jviotti
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

'use strict';

/**
 * @module hidepath
 */

var os = require('os');
var path = require('path');

/**
 * @summary Get the hidden equivalent of a file path
 * @function
 * @public
 * @name hidepath
 *
 * @description
 * This function prepends `.` or `_`, on Unix and
 * Windows respectively to the passed file path.
 *
 * @param {String} file - file path
 * @returns {String} hidden equivalent file path
 *
 * @example
 * var hidepath = require('hidepath');
 * console.log(hidepath('/home/jviotti/vimrc'));
 * > /home/jviotti/.vimrc
 */
module.exports = function(file) {

  file = (file || '').trim();

  if (!file) {
    return;
  }

  var delimiter = os.platform() === 'win32' ? '_' : '.';
  var dirname = path.dirname(file);
  var basename = path.basename(file);
  return path.join(dirname, delimiter + basename);
};
